import useHelpModal from '../HelpModal/useHelpModal';

const ChatButton: React.FunctionComponent = function () {
  const { showHelpModal } = useHelpModal();

  return (
    <button
      type="button"
      className="bg-purple-600 hover:bg-purple-700 transition-all px-8 py-3 text-14-22-em text-neutral-000 rounded-full"
      onClick={() => {
        showHelpModal();
      }}
    >
      Chat
    </button>
  );
};

export default ChatButton;
